export class AzureOnboardingStatus {
    'entityId';
    'entityType';
    'entityName';
    'sourceAccountId';
    'status';
    'message';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityName",
            "baseName": "entityName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountId",
            "baseName": "sourceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "AzureOnboardingStatusStatusEnum",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureOnboardingStatus.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureOnboardingStatusStatusEnum;
(function (AzureOnboardingStatusStatusEnum) {
    AzureOnboardingStatusStatusEnum["Accepted"] = "Accepted";
    AzureOnboardingStatusStatusEnum["Running"] = "Running";
    AzureOnboardingStatusStatusEnum["Succeeded"] = "Succeeded";
    AzureOnboardingStatusStatusEnum["Failed"] = "Failed";
})(AzureOnboardingStatusStatusEnum || (AzureOnboardingStatusStatusEnum = {}));
